import { render, staticRenderFns } from "./ModalAllotment.vue?vue&type=template&id=23a79c60&"
import script from "./ModalAllotment.vue?vue&type=script&lang=js&"
export * from "./ModalAllotment.vue?vue&type=script&lang=js&"
import style0 from "./ModalAllotment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports